<template>
    <div>
        <div v-for="product in group.pr_types">
            <div v-if="product === 'DE' && group.products && group.products[product]">

                <h4 class="text-uppercase mt-3 mb-3">
                    <font-awesome-icon icon="tooth" class="mr-1"/>
                    Dental
                </h4>
                <div v-if="group.products[product].plans">
                    <b-row>
                        <b-col md="6">
                            <b-row>
                                <b-col md="12">
                                    <b-form-group id="planSelectionLabel" label="Plan:" label-for="planSelection">
                                        <b-form-select id="planSelection" :options="planOptions(product)" v-model="model.planSelection.DE.plan">
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-if="model.planSelection && model.planSelection.DE.plan">
                                <b-col md="12">
                                    <b-form-group id="planSelectionLabel" label="Tier:" label-for="dePlanTiers">
                                        <b-form-radio-group :options="planTiers(product)" name="dePlanTier" v-model="model.planSelection.DE.tier"></b-form-radio-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="5" offset="1" v-if="model.planSelection && model.planSelection.DE.plan">
                            <b-row>
                                <b-col>
                                    <label for="fake" class="d-block">Coverage:</label>
                                    <b-form-checkbox>
                                        <strong>Employee</strong> &mdash; <span class="text-capitalize">{{model.firstName}} {{model.middleName}} {{model.lastName}}</span>
                                    </b-form-checkbox>
                                    <b-form-checkbox v-for="child in model.children">
                                        <strong>{{child.type}}</strong> &mdash; <span class="text-capitalize">{{child.firstName}} {{child.middleName}} {{child.lastName}}</span>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>

                </div>
                <div v-else class="mt-4 mb-5">
                    <b-alert show variant="danger">
                        <font-awesome-icon icon="exclamation-circle" class="mr-1"/>
                        This group has a Dental product no plans have been defined yet. Please contact your TDA account manager to correct this.
                    </b-alert>
                </div>
                <hr class="mt-3 mb-4"/>
            </div>
            <div v-if="product === 'VI' && group.products && group.products[product]">
                <h4 class="text-uppercase mt-3 mb-3">
                    <font-awesome-icon icon="eye" class="mr-1"/>
                    Vision
                </h4>
                <div v-if="group.products[product].plans">

                    <b-row>
                        <b-col md="6">
                            <b-row>
                                <b-col md="12">
                                    <b-form-group id="planSelectionLabel" label="Plan:" label-for="planSelection">
                                        <b-form-select id="planSelection" :options="planOptions(product)" v-model="model.planSelection.VI.plan">
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-show="model.planSelection.VI.plan">
                                <b-col md="12">
                                    <b-form-group id="planSelectionLabel" label="Tier:" label-for="pviPanTiers">
                                        <b-form-radio-group :options="planTiers(product)" name="viPlanTier" v-model="model.planSelection.VI.tier"></b-form-radio-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="5" offset="1" v-show="model.planSelection.VI.plan">
                            <b-row>
                                <b-col>
                                    <label for="fake" class="d-block">Coverage:</label>
                                    <b-form-checkbox>
                                        <strong>Employee</strong> &mdash; <span class="text-capitalize">{{model.firstName}} {{model.middleName}} {{model.lastName}}</span>
                                    </b-form-checkbox>
                                    <b-form-checkbox v-for="child in model.children">
                                        <strong>{{child.type}}</strong> &mdash; <span class="text-capitalize">{{child.firstName}} {{child.middleName}} {{child.lastName}}</span>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </div>
                <div v-else class="mt-4 mb-5">
                    <b-alert show variant="danger">
                        <font-awesome-icon icon="exclamation-circle" class="mr-1"/>
                        This group has a Vision product no plans have been defined yet. Please contact your TDA account manager to correct this.
                    </b-alert>
                </div>
                <hr class="mt-3 mb-4"/>
            </div>
            <div v-if="product === 'WI' && group.products && group.products[product]">
                <h4 class="text-uppercase mt-3 mb-3">
                    <font-awesome-icon icon="hospital" class="mr-1"/>
                    Short Term Disability
                </h4>
                <div v-if="group.products[product].plans">

                    <b-row>
                        <b-col md="6">
                            <b-row>
                                <b-col md="12">
                                    <b-form-group id="planSelectionLabel" label="Plan:" label-for="planSelection">
                                        <b-form-select id="planSelection" :options="planOptions(product)" v-model="model.planSelection.WI.plan">
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-show="model.planSelection.WI.plan">
                                <b-col md="12">
                                    <b-form-group id="planSelectionLabel" label="Tier:" label-for="wiPlanTiers">
                                        <b-form-radio-group :options="planTiers(product)" name="wiPlanTier" v-model="model.planSelection.WI.tier"></b-form-radio-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-show="model.planSelection.WI.plan">
                                <b-col md="12">
                                    <b-form-group id="planBenefit" label="STD Plan Benefit:">
                                        <b-input name="planBenefit" label-cols-md="6" v-model="model.planSelection.WI.benefit"></b-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="5" offset="1" v-show="model.planSelection.WI.plan">
                            <b-row>
                                <b-col>
                                    <label for="fake" class="d-block">Coverage:</label>
                                    <b-form-checkbox>
                                        <strong>Employee</strong> &mdash; <span class="text-capitalize">{{model.firstName}} {{model.middleName}} {{model.lastName}}</span>
                                    </b-form-checkbox>
                                    <b-form-checkbox v-for="child in model.children">
                                        <strong>{{child.type}}</strong> &mdash; <span class="text-capitalize">{{child.firstName}} {{child.middleName}} {{child.lastName}}</span>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </div>
                <div v-else class="mt-4 mb-5">
                    <b-alert show variant="danger">
                        <font-awesome-icon icon="exclamation-circle" class="mr-1"/>
                        This group has a Short Term Disability product no plans have been defined yet. Please contact your TDA account manager to correct this.
                    </b-alert>
                </div>
                <hr class="mt-3 mb-4"/>
            </div>
            <div v-if="product === 'LT' && group.products && group.products[product]">
                <h4 class="text-uppercase mt-3 mb-3">
                    <font-awesome-icon icon="blind" class="mr-1"/>
                    Long Term Disability
                </h4>
                <div v-if="group.products[product].plans">
                    <b-row>
                        <b-col md="6">
                            <b-row>
                                <b-col md="12">
                                    <b-form-group id="planSelectionLabel" label="Plan:" label-for="planSelection">
                                        <b-form-select id="planSelection" :options="planOptions(product)" v-model="model.planSelection.LT.plan">
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-show="model.planSelection.LT.plan">
                                <b-col md="12">
                                    <b-form-group id="planSelectionLabel" label="Tier:" label-for="ltPlanTiers">
                                        <b-form-radio-group :options="planTiers(product)" name="ltPlanTiers" v-model="model.planSelection.LT.tier"></b-form-radio-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-show="model.planSelection.LT.plan">
                                <b-col md="12">
                                    <b-form-group id="planBenefit" label="LTD Plan Benefit:">
                                        <b-input name="planBenefit" label-cols-md="6" v-model="model.planSelection.LT.benefit"></b-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="5" offset="1" v-show="model.planSelection.LT.plan">
                            <b-row>
                                <b-col>
                                    <label class="d-block">Coverage:</label>
                                    <b-form-checkbox>
                                        <strong>Employee</strong> &mdash; <span class="text-capitalize">{{model.firstName}} {{model.middleName}} {{model.lastName}}</span>
                                    </b-form-checkbox>
                                    <b-form-checkbox v-for="child in model.children">
                                        <strong>{{child.type}}</strong> &mdash; <span class="text-capitalize">{{child.firstName}} {{child.middleName}} {{child.lastName}}</span>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </div>
                <div v-else class="mt-4 mb-5">
                    <b-alert show variant="danger">
                        <font-awesome-icon icon="exclamation-circle" class="mr-1"/>
                        This group has a Long Term Disability product no plans have been defined yet. Please contact your TDA account manager to correct this.
                    </b-alert>
                </div>
            </div>
            <div v-if="product === 'LA'">
                <h4 class="text-uppercase mt-3 mb-3">
                    <font-awesome-icon icon="life-ring" class="mr-1"/>
                    Basic Life
                </h4>
                <b-row>
                    <b-col md="6">
                        <b-row>
                            <b-col md="12">
                                <b-checkbox v-model="model.planSelection.LA.plan">Basic Life Plan</b-checkbox>
                            </b-col>
                        </b-row>
                        <b-row v-show="model.planSelection.LA.plan">
                            <b-col md="12">
                                <b-form-group id="diBenefitLabel" label="Benefit Level:" label-for="diBenefit">
                                    <b-input id="diBenefit" type="number"></b-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <hr class="mt-3 mb-4"/>
            </div>
            <div v-if="product === 'VL'">
                <h4 class="text-uppercase mt-3 mb-3">
                    <font-awesome-icon icon="life-ring" class="mr-1"/>
                    Voluntary Life
                </h4>
                <b-row>
                    <b-col md="6">
                        <b-row>
                            <b-col md="12">
                                <b-checkbox v-model="model.planSelection.VL.plan">Voluntary Life Plan</b-checkbox>
                            </b-col>
                        </b-row>
                        <b-row v-show="model.planSelection.VL.plan">
                            <b-col md="12">
                                <b-form-group id="diBenefitLabel" label="Benefit Level:" label-for="diBenefit">
                                    <b-input id="diBenefit" type="number"></b-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <hr class="mt-3 mb-4"/>
            </div>
            <div v-if="product === 'VC'">
                <h4 class="text-uppercase mt-3 mb-3">
                    <font-awesome-icon icon="child" class="mr-1"/>
                    Voluntary Child
                </h4>
                <b-row>
                    <b-col md="6">
                        <b-row>
                            <b-col md="12">
                                <b-checkbox v-model="model.planSelection.VC.plan">Voluntary Child Plan</b-checkbox>
                            </b-col>
                        </b-row>
                        <b-row v-show="model.planSelection.VC.plan">
                            <b-col md="12">
                                <b-form-group id="diBenefitLabel" label="Benefit Level:" label-for="diBenefit">
                                    <b-input id="diBenefit" type="number"></b-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <hr class="mt-3 mb-4"/>
            </div>
            <div v-if="product === 'VD'">
                <h4 class="text-uppercase mt-3 mb-3">
                    <font-awesome-icon icon="user-friends" class="mr-1"/>
                    Voluntary Dependent Life
                </h4>
                <b-row>
                    <b-col md="6">
                        <b-row>
                            <b-col md="12">
                                <b-checkbox v-model="model.planSelection.VD.plan">Voluntary Dependent Plan</b-checkbox>
                            </b-col>
                        </b-row>
                        <b-row v-show="model.planSelection.VD.plan">
                            <b-col md="12">
                                <b-form-group id="diBenefitLabel" label="Benefit Level:" label-for="diBenefit">
                                    <b-input id="diBenefit" type="number"></b-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <hr class="mt-3 mb-4"/>
            </div>
            <div v-if="product === 'DL'">
                <h4 class="text-uppercase mt-3 mb-3">
                    <font-awesome-icon icon="users" class="mr-1"/>
                    Dependent Life
                </h4>
                <b-row>
                    <b-col md="6">
                        <b-row>
                            <b-col md="12">
                                <b-checkbox v-model="model.planSelection.DL.plan">Dependent Life Plan</b-checkbox>
                            </b-col>
                        </b-row>
                        <b-row v-show="model.planSelection.DL.plan">
                            <b-col md="12">
                                <b-form-group id="diBenefitLabel" label="Benefit Level:" label-for="diBenefit">
                                    <b-input id="diBenefit" type="number"></b-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <hr class="mt-3 mb-4"/>
            </div>
            <div v-if="product === 'DI'">
                <h4 class="text-uppercase mt-3 mb-3">
                    <font-awesome-icon icon="hospital" class="mr-1"/>
                    Disability
                </h4>
                <b-row>
                    <b-col md="6">
                        <b-row>
                            <b-col md="12">
                                <b-checkbox v-model="model.planSelection.DI.plan">Disability Plan</b-checkbox>
                            </b-col>
                        </b-row>
                        <b-row v-show="model.planSelection.DI.plan">
                            <b-col md="12">
                                <b-form-group id="diBenefitLabel" label="Benefit Level:" label-for="diBenefit">
                                    <b-input id="diBenefit" type="number"></b-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
            <div v-if="product === 'CI'">
                <h4 class="text-uppercase mt-3 mb-3">
                    <font-awesome-icon icon="user-injured" class="mr-1"/>
                    Critical Illness
                </h4>
                <b-row>
                  <b-col md="6">
                  <b-row>
                    <b-col md="12">
                    <b-checkbox v-model="model.planSelection.CI.plan">Critical Illness Plan</b-checkbox>
                    </b-col>
                  </b-row>
                  <b-row v-show="model.planSelection.CI.plan">
                    <b-col md="12">
                    <b-form-group id="diBenefitLabel" label="Benefit Level:" label-for="diBenefit">
                      <b-input id="diBenefit" type="number"></b-input>
                    </b-form-group>
                    </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <hr class="mt-3 mb-4"/>
            </div>
        </div>

        <b-row>
            <b-col md="10">
                <h3>Effective Date</h3>
                <b-form-group id="effectiveDateLabel"
                              label="Effective Date:"
                              label-for="effectiveDate">
                    <b-form-input
                            id="effectiveDate"
                            type="month"
                            v-model="model.effectiveDate">
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: 'PlanSelection',
        props: ['model', 'group'],
        methods: {
            planOptions(product) {
                if (this.group.products[product]) {
                    return this.group.products[product]['options']
                }
                return []
            },
            planTiers(product) {
                let tiers = []
                if (this.group.products[product]) {
                    this.group.products[product]['plans'].forEach(plan => {
                        if (plan.plan_code === this.model.planSelection[product].plan) {
                            tiers = plan.tiers
                        }
                    })
                }
                return tiers
            }
        },
        data: function () {
            return {
                products: []
            }
        }
    }
</script>

<style scoped>

</style>
